export function useNewContactMessage(modelValue, isShipper) {

    if (isShipper) {

        return !!(!modelValue.shipper.shipperContactFullName &&
            modelValue.shipper.shipperContactFirstName && modelValue.shipper.shipperContactLastName);

    } else {

        return !!(!modelValue.consignee.consigneeContactFullName && modelValue.consignee.consigneeContactFirstName
            && modelValue.consignee.consigneeContactLastName);
    }

}
